<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Check In Ticket Page" aria-live="polite" role="contentinfo"></span>
    <p class="public-h5 font-weight-bold">
      {{ siteText.ui.checkInTicketHeader }}
    </p>
    <v-card class="align-center justify-center" v-if="displayTicket">
      <check-in-ticket
        :ticketNumber="ticketNumber"
        :bookingType="bookingType"
        :firstName="firstName"
        :lastName="lastName"
        :siteName="siteName"
        :formattedBookingDate="formattedBookingDate"
        :formattedCheckInDate="formattedCheckInDate"
        :serviceOne="serviceOne"
        :serviceTwo="serviceTwo"
        :formatedPhone="formatedPhone"
      >
      </check-in-ticket>
    </v-card>
    <v-card class="d-flex align-center justify-center" v-if="displayTicketNotFound">
      <v-card-text class="red--text">
        {{ siteText.ui.checkInTicketNotFoundText }}
      </v-card-text>
    </v-card>
</div>
</template>

<script>
import nyApi from '@/api/nyApi';
import CheckInTicket from '../components/CheckInTicket.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'CheckInTicketPage',
  components: {
    CheckInTicket,
  },
  data: () => ({
    formattedCheckInDate: '',
    formattedBookingDate: '',
    ticketNumber: '',
    bookingType: 'checkin',
    firstName: '',
    lastName: '',
    formatedPhone: '',
    serviceOne: '',
    serviceTwo: '',
    siteName: '',
    displayTicket: false,
    displayTicketNotFound: false,
  }),
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['viewTicketGuid','isRTLLanguage']),
  },
  async mounted() {
    console.log(this.viewTicketGuid);
    try {
      const response = await nyApi.GetTicketData(this.viewTicketGuid);
      console.log(response);
      this.ticketNumber = response.ticketNumber;
      console.log(this.ticketNumber);
      if (this.ticketNumber) {
        this.displayTicket = true;
        this.formattedCheckInDate = response.formattedCheckInDate;
        this.formattedBookingDate = response.formattedBookingDate;
        this.firstName = response.firstName;
        this.lastName = response.lastName;
        if (!this.firstName && !this.lastName) {
          this.bookingType = 'walkin';
          const x = response.mobilePhone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
          // eslint-disable-next-line prefer-template
          this.formatedPhone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        }
        this.siteName = response.siteName;
        if (response.serviceType) {
          console.log(response.serviceType);
          this.serviceOne = response.serviceType;
        }
        if (response.serviceType2) {
          console.log(response.serviceType2);
          this.serviceTwo = response.serviceType2;
        }
      } else {
        this.displayTicketNotFound = true;
      }
    } catch (error) {
      console.log(error);
      this.displayTicketNotFound = true;
    } finally {
      console.log('Inside check-in ticket page mounted finally');
    }
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}

.v-card {
  min-height: 100px !important;
  padding: 20px !important;
}
</style>
